"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const light_exception_1 = require("./common/light-exception");
const LightValidateDecorator = require("./common/light-validate.decorator");
const LightExtendDecorator = require("./common/light-extend.decorator");
function validate(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        return lightValidate(target, klass, ...properties);
    });
}
exports.validate = validate;
function validateOne(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        return lightValidateOne(target, klass, ...properties);
    });
}
exports.validateOne = validateOne;
function validateEach(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        return lightValidateEach(target, klass, ...properties);
    });
}
exports.validateEach = validateEach;
function lightValidate(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        if (target && Array.isArray(target)) {
            return lightValidateEach(target, klass, ...properties);
        }
        else if (target) {
            return lightValidateOne(target, klass, ...properties);
        }
    });
}
exports.lightValidate = lightValidate;
function lightValidateOne(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        const errors = yield exceptionsByOne(target, klass, ...properties);
        return errors.length ? Promise.reject(errors) : Promise.resolve();
    });
}
exports.lightValidateOne = lightValidateOne;
function lightValidateEach(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        const errors = yield exceptionsByEach(target, klass, ...properties);
        return errors.length ? Promise.reject(errors) : Promise.resolve();
    });
}
exports.lightValidateEach = lightValidateEach;
function exceptionsBy(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        if (target && Array.isArray(target)) {
            return exceptionsByEach(target, klass, ...properties);
        }
        else if (target) {
            return exceptionsByOne(target, klass, ...properties);
        }
        else {
            return [];
        }
    });
}
exports.exceptionsBy = exceptionsBy;
function exceptionsByEach(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        return Promise.all(target.map(item => exceptionsByOne(item, klass, ...properties)))
            .then(arrays => arrays.reduce((initial, current) => initial.concat(current), []));
    });
}
exports.exceptionsByEach = exceptionsByEach;
function exceptionsByOne(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        return Promise.all([
            exceptionsByLightValidate(target, klass, ...properties),
            exceptionsByLightExtend(target, klass, ...properties)
        ])
            .then(exceptions => exceptions.reduce((initial, current) => initial.concat(current)));
    });
}
exports.exceptionsByOne = exceptionsByOne;
function exceptionsByLightValidate(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        const klassInstance = new klass;
        let errors = [];
        const klassProperties = (properties && properties.length) ? properties : Object.keys(klassInstance).filter(property => LightValidateDecorator.hasMetadata(property, klassInstance));
        while (klassProperties.length) {
            const property = klassProperties.shift();
            const rules = [...LightValidateDecorator.getMetadataValue(property, klassInstance)];
            while (rules.length) {
                const rule = rules.shift();
                yield rule(target[property], target)
                    .catch((code) => {
                    const error = Object.assign(new light_exception_1.LightException(), { rule: rule, target: target, property: property, code: code });
                    errors = [...errors, error];
                });
            }
        }
        return errors;
    });
}
exports.exceptionsByLightValidate = exceptionsByLightValidate;
function exceptionsByLightExtend(target, klass, ...properties) {
    return __awaiter(this, void 0, void 0, function* () {
        const klassInstance = new klass;
        let errors = [];
        const klassProperties = (properties && properties.length) ? properties : Object.keys(klassInstance).filter(property => LightExtendDecorator.hasMetadata(property, klassInstance));
        while (klassProperties.length) {
            const property = klassProperties.shift();
            const uses = [...LightExtendDecorator.getMetadataValue(property, klassInstance) || []];
            while (uses.length) {
                const use = uses.shift();
                yield exceptionsBy(target[property], use)
                    .then(targetErrors => errors = [...targetErrors, ...errors]);
            }
        }
        return errors;
    });
}
exports.exceptionsByLightExtend = exceptionsByLightExtend;
//# sourceMappingURL=callable.js.map